import { useTranslation } from "react-i18next";
import GenericCrudTable from "@/components/tables/genericCrudTable";
import { getRecordMetadataColumns } from "@/components/tables/recordMetadataColumns";
import RestrictedPage from "@/consumer/restrictedPage";
import { replaceDate } from "@/helper/dateHandling";
import { usePageHeading } from "@/helper/customHooks/usePageHeading";

export default function MainCategoryList() {
  const { t } = useTranslation();
  usePageHeading(t("main_categories"));

  return (
    <RestrictedPage permissionRequired="frontend_view_main_category">
      <GenericCrudTable
        entity="mainCategory"
        allowColumnFiltering={true}
        showColumnFilterbyDefault={true}
        additionalUrlParameter={{ include_relations: true }}
        columns={[
          { header: t("id"), accessorKey: "id", id: "id", enableEditing: false },
          {
            header: t("name"),
            accessorKey: "name",
            id: "name",
            enableForCreate: true,
            required: true,
            errorMessage: t("field_required"),
          },
          {
            header: t("description"),
            accessorKey: "description",
            id: "description",
            enableForCreate: true,
            textarea: true,
          },
          {
            header: t("internal_usage"),
            id: "internal_usage",
            accessorKey: "internal_usage",
            enableForCreate: true,
            selectOptions: [
              { value: true, label: t("yes") },
              { value: false, label: t("no") },
            ],
            accessorFn: (row: any) => {
              if (row.internal_usage) {
                return t("yes");
              } else {
                return t("no");
              }
            },
            filterVariant: "checkbox",
          },
          {
            header: t("created_on"),
            accessorKey: "created_on",
            id: "created_on",
            sortingFn: "datetime",
            filterVariant: "date",
            Cell: ({ cell }: any) => {
              return <span>{replaceDate(cell.getValue(), true, true)}</span>;
            },
          },
          {
            header: t("created_by"),
            accessorKey: "created_by",
            customColumnFilterId: "created_by_name",

            id: "created_by",
            Cell: ({ cell }: any) => {
              return <span>{cell.getValue()?.name}</span>;
            },
          },
          {
            header: t("modified_on"),
            accessorKey: "modified_on",
            id: "modified_on",
            filterVariant: "date",
            sortingFn: "datetime",
            Cell: ({ cell }: any) => {
              return <span>{replaceDate(cell.getValue(), true, true)}</span>;
            },
          },
          ...getRecordMetadataColumns(t, ["modified_by"]),
        ]}
      />
    </RestrictedPage>
  );
}
